module.exports = __webpack_public_path__ + "img/banner-sep-2023.cbc3cfce.jpg";